module.exports = __webpack_public_path__ + "static/media/logo.5ea1f10f.svg";